<div class="row">
    <div class="btn-group btn-breadcrumb">
        <ng-container *ngFor="let crumb of crumbList">
            <a href="javascript:void(0)" [routerLink]="[crumb.url]" 
                    class="breadcrumb-item">
               {{crumb.title}}
            </a> 
        </ng-container>
    </div>
</div> 